import React               from 'react';
import PropTypes           from 'prop-types';
import Flux                 from '../../../flux/Flux';
import {getCompleteDataset} from "../../../utils/CommonUtils";

function withTVSeries(WrappedComponent) {

	class withTVSeries extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				series:  this.getTVSeriesFromStore(),
				loading: true,
			};

			this.onTVSeriesDataChange = this.onTVSeriesDataChange.bind(this);
			this.onTVSeriesLoad       = this.onTVSeriesLoad.bind(this);
			this.getTVSeriesFromStore = this.getTVSeriesFromStore.bind(this);
			this.loadTVSeries         = this.loadTVSeries.bind(this);
		}

		componentDidMount() {
			Flux.TVSeries.addTVSeriesDataChangeListener(this.onTVSeriesDataChange);
			Flux.TVSeries.addTVSeriesLoadListener(this.onTVSeriesLoad);

			this.loadTVSeries();
		}

		componentDidUpdate(prevProps) {
			if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
				this.loadTVSeries();
			}
		}

		componentWillUnmount() {
			Flux.TVSeries.removeTVSeriesDataChangeListener(this.onTVSeriesDataChange);
			Flux.TVSeries.removeTVSeriesLoadListener(this.onTVSeriesLoad);
		}

		onTVSeriesLoad() {
			const loading = Flux.TVSeries.isTVSeriesLoading();
			this.setState({
				loading,
			});
		}

		loadTVSeries() {
			const series  = this.getTVSeriesFromStore();
			const loading = Flux.TVSeries.isTVSeriesLoading();

			if (!loading) {
				if (!series) {
					Flux.TVSeries.loadTVSeries(this.props.count, this.props.offset);
				} else {
					this.setState(() => ({series, loading}));
				}
			}
		}

		onTVSeriesDataChange() {
			const series  = this.getTVSeriesFromStore();
			const loading = series ? false : this.state.loading;
			this.setState(() => ({series, loading}));
		}

		getTVSeriesFromStore() {
			const getItems = () => Flux.TVSeries.getTVSeries();

			const getTotalCount = () => Flux.TVSeries.getTVSeriesTotalCount();

			return getCompleteDataset(getItems, getTotalCount, this.props.count, this.props.offset);
		}

		render() {
			return <WrappedComponent {...this.state} {...this.props} />;
		}
	}

	withTVSeries.propTypes    = {
		offset: PropTypes.number,
		count:  PropTypes.number,
	};
	withTVSeries.defaultProps = {
		offset: 0,
		count:  5,
	};

	return withTVSeries;
}

export default withTVSeries;
